export default __webpack_public_path__ + "static/media/PAYTM2.85e2822f.png";